export default {"src":"/_next/static/image/public/images/flags/flag_1242.c4d5bc41d8ca2f7a267f9b8d20330fe3.svg","height":16,"width":24};